<!-- <mat-sidenav-container class="main-container" [class.shoMyDelvery]="enableRSMenu" *ngIf="(Menus['sortedLinks']?.length > 0 && featureTags['category_menu_auto_generate'] && this.screenWidth >= 800) || !featureTags['category_menu_auto_generate'] || this.screenWidth <= 800"> -->
    
    <mat-sidenav [opened]="false" mode="over" #sidenav class="sidenav mat-elevation-z6 sidenav-overflow">
        <div [ngStyle]=" {'background':settings.theme}" class="pt-8 sideDiv">
            <button mat-icon-button color="primary" class="close bg-wht" (click)="sidenav.close()">
                <i class="material-icons primary" data-icon="close"></i>
            </button>
            <img *ngIf="!loggedIn" class="profile" alt="Profile" 
            src="assets/images/default-avatar.png">
            <div class="avatar" *ngIf="loggedIn">
                {{userDetails['first_name'] | slice: 0: 1 | titlecase}}{{userDetails['last_name'] | slice: 0: 1 |
                titlecase}}
            </div>
            <h5 *ngIf="loggedIn === true" class="name">{{userDetails['first_name']}} {{userDetails['last_name']}}</h5>
        </div>
        <div class="mob-search">
            <form [formGroup]="searchForm" class="search-form" fxLayout="row">
                <input type="text" placeholder="Type to search..." fxFlex 
                (keydown.enter)="mobileSearch(searchForm.value)" formControlName="keyword">
                <button mat-mini-fab (click)="mobileSearch(searchForm.value)" matTooltip="search products" type="button"
                    class="search-btn mat-elevation-z0 text-muted">
                    <i class="material-icons" data-icon="search"></i>
                </button>
            </form>
        </div>
    
        <div *ngIf="Menus['sortedLinks']">
            <ng-container *ngIf="featureTags && !featureTags['sf_side_menu_global_change']">
                <div *ngIf="categories?.length > 0">
                    <app-sidenav-menu [menuItems]="categories" [menuParentId]="0" (emitPass)="handleChange($event)"></app-sidenav-menu>
                  </div>
            </ng-container>
            <ng-container *ngIf="featureTags && featureTags['sf_side_menu_global_change']">
                <div *ngIf="categories?.length > 0 && sidenavMenuItems['desktop_links']">
                    <app-sidenav-menu [menuItems]="categories" [menuParentId]="0" [accountMenuItems]="sidenavMenuItems" 
                    (emitPass)="handleChange($event)"></app-sidenav-menu>                        
                </div>
            </ng-container>
        <ng-container *ngIf="featureTags && !featureTags['sf_side_menu_global_change']">
            <div *ngFor = "let menuItem of sidenavMenuItems['desktop_links']">
                <div  *ngIf = "menuItem['title']['display']">
                    <a  mat-button  *ngIf = "menuItem['title']['display']['desktop'] === true"
                    fxLayout="row" fxLayoutAlign="start center" 
                    routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"
                        (click)="handleChange(menuItem)"
                        [ngClass]="!!menuItem['title']['cssClass'] ? menuItem['title']['cssClass'] : ''">
                        <span *ngIf = "menuItem['title']['type'] === 'public'" class="text-uppercase menu-title1" [innerHTML]="menuItem['title']['name'] | sanitizeHtml ">check1</span>
                        <span *ngIf = "menuItem['title']['type'] === 'private' && loggedIn" class="text-uppercase menu-title1"  [innerHTML]="menuItem['title']['name'] | sanitizeHtml ">check2</span>
                    </a>
                    <div class="menu-item" *ngFor="let subLinks of menuItem['links']"
                        [class.active]="router.url === '/'+subLinks.href">
                        <a  mat-button  *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true"
                        fxLayout="row" fxLayoutAlign="start center" class="pl-0"
                        routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"        
                        (click)="handleChange(subLinks)" >
                            <mat-icon  class="mat-icon-sm pad-right pl-10 pr-5" *ngIf = "subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] !== 'sign-in'">{{subLinks['icon']}}</mat-icon>
                            <span *ngIf = "subLinks['type'] === 'public'  && subLinks['href'] !== 'sign-in' " class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                            <mat-icon class="mat-icon-sm pad-right pl-10 pr-5" *ngIf = "subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn">{{subLinks['icon']}}</mat-icon>
                            <span *ngIf = "subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn" class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                            <mat-icon class="mat-icon-sm pad-right pl-10 pr-5" *ngIf = "subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'private' && loggedIn">{{subLinks['icon']}}</mat-icon>
                            <span *ngIf = "subLinks['type'] === 'private' && loggedIn" class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="menu-item">
                <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0  bo-5 " [routerLink]="['/contact']">
                    <span  >CONTACT US</span>
                </a>
            </div>
        </ng-container>
        </div>
        <div class="divider"></div>
        <div class="text-center py-1 socialIconsSN" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
            <a *ngFor="let SI of storeDetailsJson['socialMedia']" [href]="SI.href" target="_blank">
                <i [class]="'fa fa-'+SI.icon"></i>
            </a>
        </div>
    </mat-sidenav>
    <div id="GrisonDairyHeader">
    <!-- HudsonMilk Header Start -->
    <!-- <h1>==========HEADER===============</h1> -->
    <mat-toolbar>
        <div class="searchProducts" *ngIf="isShowSearch">
            <div fxFlex="96%" fxFlex.gt-sm="50%" fxShow.gt-sm>
                <app-search-products 
                    #searchProductsInDesktopView
                    [store]="storeDetails"
                    [user]="userDetails"
                    [showSearchResult]="showSearchProductsResult"></app-search-products>
            </div>
            <!-- <div class="inputGrp">
                <input type="search">
                <div class="actionSearch">
                    <i class="fa fa-search"></i>
                    <button type="button" (click)="SearchProductsFn()">Cancel</button>
                </div>
            </div> -->
        </div>
        <mat-toolbar-row class="toolbarBg" fxHide>
            <div class="containerLg containerLgMbl" fxLayout="row" fxLayoutAlign="space-between center" #top>
                <span class="btnNavIcon" fxHide.gt-md>
                    <button mat-button (click)="sidenav.toggle()" class="sidenav-toggle menuBtn">
                        <i class="material-icons md-36" data-icon="menu"></i>
                    </button>
                </span>
                <a fxHide class="telInfo" href="tel:+{{storeDetails['phone'] | phone: 'US'}}" fxLayoutAlign="center center">
                    <i class="material-icons md-18 " data-icon="call"></i>
                    {{storeDetails['phone'] | phone: 'US'}}
                </a>
                <span fxHide class="welTxt" style="font-weight: 600;"
                    *ngIf="storeDetailsJson['header']">{{storeDetailsJson['header']['welcomeText']}}</span>
                <div class="socialIcons SIHeader">
                    <ul class="list-inline" fxLayout="row" fxLayoutGap="15px">
                        <li *ngFor="let x of storeDetailsJson['socialMedia']">
                            <a [href]="x.href" target="_blank">
                                <i [class]="'fa fa-'+x.icon" aria-label="Socialmedia"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-toolbar-row>
        <mat-toolbar-row style="height: auto !important; width: 100%; padding-top: 8px; padding-bottom: 8px;" class="headerLogo" fxShow.gt-sm>
            <div class="containerLg" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                    <a *ngIf="storeDetailsJson['header'] && storeDetailsJson['header']['logoImage'] === ''" class="logo"
                    [href]="storeDetailsJson?.header?.logourl" (click)="closeSubMenus()">
                        {{storeDetailsJson['header']['logoText']}}
                    </a>
                    <a fxLayout="row"
                        *ngIf="storeDetailsJson['header'] && storeDetailsJson['header']['logoImage'] !== ''"
                        (click)="closeSubMenus()"  [href]="storeDetailsJson?.header?.logourl" class="mobileNavMenu"
                        fxLayoutAlign.lt-md="center center">
                        <span class="btnNavIcon" fxHide.gt-sm>
                            <button mat-button (click)="sidenav.toggle()" class="sidenav-toggle menuBtn">
                                <i class="material-icons md-36" data-icon="menu"></i>
                            </button>
                        </span> 
                        <img [src]="storeDetailsJson['header']['logoImage']" class="brandLogo" alt="Logo"
                            [ngStyle]="{'background': storeDetailsJson['settings']['imageBackground']}" />   
                    </a>
                </div>
                <div fxHide.lt-md> 
                    <ul class="list-inline navMenu" fxLayout="row">
                        <li class="hand-hover" *ngFor="let link of sidenavMenuItems['main_menu']">
                            <!-- [href]="link.title.href" -->
                            <a (click)="goCms(link)">{{link.title.name}}</a>
                        </li>
                        <li (click)="SearchProductsFn()" class="hand-hover">
                            <mat-icon class="serchIc" id="searchbtn">search</mat-icon>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul class="list-inline userAccout" fxLayout="row">
                        <li fxHide.gt-sm>
                            <button class="mbSearch" (click)="SearchProductsFn()" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
                                <mat-icon>search</mat-icon>
                            </button>
                        </li>
                        <li style="margin: 0 !important;">
                            <app-top-menu *ngIf="sidenavMenuItems['desktop_links']"
                                [menuItems]="sidenavMenuItems['desktop_links']" [menuParentId]="0"
                                (emitPass)="handleChange($event)" fxShow.gt-sm></app-top-menu>
                            <!-- <a href="/login.php" class="login">Sign In</a> -->
                        </li>
                        <li class="cart-li" style="margin: 0 !important;">
                            <div class="cart-action cartBtm" id="cart-link" (click)="enableRMenu()">
                                <a routerLink="/edit-order">
                                    <mat-icon>shopping_basket</mat-icon>
                                </a>
                                <sup class="initials1 cartcount">{{cartData.items}}</sup> 
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- End -->
        </mat-toolbar-row>
    </mat-toolbar>
    
    <!-- HudsonMilk Header ends -->
    <!-- <ng-container *ngIf="showCategories && featureTags && featureTags['sf_desktop_sub_cat']"> -->
        <mat-toolbar  id="categoriesMenu" *ngIf="Menus['sortedLinks']"
            [class.isHide]="isCmsView" fxShow.gt-sm class="top-navbar mat-elevation-z2" fxLayoutAlign="center center">
    <app-desktop-menu *ngIf="categories" [categoriesMenu]="Menus['sortedLinks']" [allCategoriesMenu]="categories"></app-desktop-menu>
    </mat-toolbar>
    <!-- </ng-container> -->
   </div>
    <!-- [ngClass]="(router.url === '/index' || router.url === '/index') ? 'DefaultView' : 'IsProductsPage'" -->
    <div id="GrisonThemeContainer" class="theme-container main" ngStyle.lt-md="margin: 0;" [class.fullW]="isCmsView" (click)="onClickSearch()">
        <!-- Delivery Calendar -->
        <!-- <div class="full-width-calendar">
            <app-delivery-calendar *ngIf="loggedIn"></app-delivery-calendar>
        </div> -->
        <!-- [class.fullWidth]="isCmsView" -->
        <!-- <app-breadcrumb *ngIf="!isMobile"  [categories]="categories" [vendors] = "vendors"></app-breadcrumb> -->
        <div fxLayout="row wrap" *ngIf="router.url != '/membership-purchase' &&  !isMobile &&  router.url !== '/edit-order'">
            <div fxFlex="100" *ngIf="!isCmsView">
                <mat-card fxLayout="row" class="breadcrumb light-block">
                    <a  class="breadcrumb-item" fxLayout="row"
                        fxLayoutAlign="start center" (click)="closeSubMenus('category')">
                        <i class="material-icons homeicon" data-icon="home"></i>
                        <span class="breadcrumb-title">Homepage</span>
                    </a>
                    <div *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item" fxLayout="row"
                        fxLayoutAlign="start center">
                        <a [hidden]="i == (breadcrumbs.length - 1)"
                            [routerLink]="[breadcrumb.url]">{{breadcrumb.name}}</a>
                        <span [hidden]="i != (breadcrumbs.length - 1)"
                            class="breadcrumb-title active"><b>{{breadcrumb.name}}</b></span>
                    </div>
                </mat-card>
            </div>
        </div>
        <!-- <router-outlet></router-outlet> -->
    </div>

    <!-- <app-footer></app-footer> -->
<!-- </mat-sidenav-container> -->




<!-- <header fxLayout="row" fxLayoutAlign="start center">
    <div class="grisonLogo" fxFlex="100px">
        <img src="https://static.wixstatic.com/media/cf6097_860e0baff1ec444b92fc9ddbf0d859ea~mv2.jpg/v1/fill/w_269,h_269,al_c,q_80,usm_0.66_1.00_0.01,enc_auto/cf6097_860e0baff1ec444b92fc9ddbf0d859ea~mv2.jpg" alt="">
    </div>
    <div class="CartMenus" fxFlex="auto" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="30px">
        <ul>
            <li><a routerLink="/home">Home</a></li>
            <li><a routerLink="/products">Shop</a></li>
            <li><a routerLink="/the-farm">The Farm</a></li>
            <li><a routerLink="/the-cheesemaker">The cheesemaker</a></li>
            <li><a routerLink="/our-cheeses">Our Cheese</a></li>
            <li><a routerLink="/where-to-buy">Where to Buy</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="javascript:void(0)"><mat-icon class="serchIc">search</mat-icon></a></li>
        </ul>
        <div class="cartSign">
            <ul fxLayout="row" fxLayoutAlign="start center">
                <li>
                    <a routerLink="/sign-in" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px"><mat-icon>input</mat-icon> <span>sign In</span></a>
                </li>
                <li fxLayout="row" fxLayoutAlign="start center"><a routerLink="/cart"><mat-icon>shopping_basket</mat-icon></a></li>
            </ul>
        </div>
    </div>
</header> -->